import React, {Component} from 'react';

import {AccessService} from '../../utils/AccessService';
import {LocalStorage} from '../../utils/LocalStorage';
import {DashboMCPContent} from './DashboMCPContent';
import {DashboMCPUpgrade} from './DashboMCPUpgrade';
import {Spinner} from '../Spinner';

class DashboMCPPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modules: null
        };
    }

    componentDidMount() {
        const userId = LocalStorage.fetchUserId();
        AccessService.GetUserModules(userId, (data) => {
            this.setState({modules: data.modules});
        });
    }

    render() {
        const {modules} = this.state;

        const hasAccess = modules && modules.includes(AccessService.MODULE_DASHBO_MCP);

        return (
            <section className="section-content">
                {modules === null ? (
                    <Spinner/>
                ) : hasAccess ? (
                    <DashboMCPContent/>
                ) : (
                    <DashboMCPUpgrade/>
                )}
            </section>
        );
    }
}

export {DashboMCPPageComponent as DashboMCPPage};
